<!--  -->
<template>
  <div class="sp_view">
    <div class="tabselecr_box">
      <div class="search_box">
        <!-- <el-input v-model="query.sp_strategy_no" clearable style="width:280px;margin-right:10px" placeholder="请输入策略编号" />
        <el-input v-model="query.sp_strategy_title" clearable style="width:280px;margin-right:10px" placeholder="请输入策略标题" /> -->
        <el-input
          v-model="query.keywords"
          clearable
          style="width:250px;"
          placeholder="请输入策略编号/策略标题"
        />
        <el-select
          v-model="query.onlyMe"
          placeholder="请选择"
        >
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select
          v-model="query.push_method"
          placeholder="请选择"
        >
          <el-option
            v-for="item in accountarrsa"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select
          v-model="query.sp_strategy_type"
          placeholder="请选择策略类型"
        >
          <el-option
            v-for="item in sparr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select
          v-model="query.status"
          placeholder="请选择状态"
        >
          <el-option
            v-for="item in statusarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchclick"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="rechargeclick"
        >重置</el-button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectlist.length==0"
          @click="batchDelete"
        >批量删除</el-button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectlist.length==0"
          @click="batchStop"
        >批量暂停</el-button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectlist.length==0"
          @click="batchStar"
        >批量启动</el-button>
      </div>
      <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="add"
        >新增策略</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      :row-key="rowKey"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        width="55"
        :reserve-selection="true"
      />
      <!-- <el-table-column
        prop="id"
        label="id"
        align="center"
        width="50"
      /> -->
      <el-table-column
        prop="sp_strategy_no"
        label="策略编号"
        align="center"
        width="250"
      />
      <el-table-column
        prop="corp_id"
        label="策略标题"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <!-- <div class="content_box">{{ scope.row.sp_strategy_title }}</div> -->
          <el-popover
            placement="top-start"
            title="策略标题"
            width="300"
            trigger="hover"
            :content="scope.row.sp_strategy_title"
          >
            <div
              slot="reference"
              class="sedrtw"
            >{{ scope.row.sp_strategy_title }}</div>
          </el-popover>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="content"
        label="付费情况"
        align="center"
        width="100"
      >
        <template>
          <div>未付费</div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column
            prop="content"
            label="消息文本"
            align="center"
            width="160"
          >
            <template slot-scope="scope">
              <div class="content_box">{{ scope.row.content }}</div>
            </template>
          </el-table-column> -->
      <el-table-column
        prop="sp_strategy_type_text"
        label="策略类型"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.sp_strategy_type_text }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="group_selection_text"
        label="发送对象类型"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.group_selection_text }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="push_method_text"
        label="发送方式"
        align="center"
        width="110"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.push_method_text }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="trigger_way_text"
        label="触发方式"
        align="center"
        width="110"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.trigger_way_text }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="user_wheres_text"
        label="关注时间"
        align="center"
        width="250"
      >
        <template slot-scope="scope">
          <div v-html="scope.row.user_wheres_text" />
        </template>
      </el-table-column>
      <el-table-column
        prop="status_text"
        label="状态"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status_text ==='正常'? 'success':'danger'">{{ scope.row.status_text }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_time_text"
        label="创建时间"
        align="center"
        width="200"
      />
      <el-table-column
        prop="realName"
        label="创建人"
        align="center"
      />
      <el-table-column
        label="操作"
        align="center"
        :width="isMobile ? 150 : 300"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.group_selection === 3"
            style="color: #13CE66"
            type="text"
            @click="bandstaff(scope.row.sp_strategy_no,scope.row.group_selection,scope.row.push_method,scope.row.sp_strategy_type,scope.row.trigger_way)"
          >绑定群</el-button>
          <el-button
            v-else-if="scope.row.group_selection === 5"
            style="color: #13CE66"
            type="text"
            @click="bandrule(scope.row.sp_strategy_no)"
          >绑定规则</el-button>
          <el-button
            v-else-if="scope.row.sp_strategy_type === 6"
            style="color: #13CE66"
            type="text"
            @click="bandrule(scope.row.sp_strategy_no)"
          >绑定规则</el-button>
          <el-button
            v-else
            type="text"
            style="color: #13CE66"
            @click="bandstaff(scope.row.sp_strategy_no,scope.row.group_selection,scope.row.push_method,scope.row.sp_strategy_type)"
          >绑定员工</el-button>
          <!-- <el-button type="success" size="mini" @click="bandstaff(scope.row.sp_strategy_no,scope.row.group_selection,scope.row.push_method)">{{ scope.row.group_selection === 3? '绑定群':'绑定员工' }}</el-button> -->
          <el-button
            type="text"
            style="color: #909399"
            @click="bandtakenotes(scope.row)"
          >绑定记录</el-button>
          <!--            @click="bandtakenotes(scope.row.sp_strategy_no,scope.row.group_selection,scope.row.push_method)"-->
          <el-button
            type="text"
            style="color: #FFBA00"
            @click="multiplex(scope.row.sp_strategy_no,2)"
          >编辑</el-button>
          <el-dropdown
            trigger="click"
            style="margin-left: 10px"
            placement="bottom"
          >
            <span
              class="el-dropdown-link"
              style="cursor: pointer;"
            >
              更多
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  v-if="[2,5].includes(scope.row.sp_strategy_type)"
                  type="text"
                  class="el-button-new"
                  icon="el-icon-video-pause"
                  @click="suspendStrat(scope.row)"
                >{{ scope.row.status === 2?'启用':'暂停' }}</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  v-if="scope.row.sp_strategy_type!==4"
                  type="text"
                  class="el-button-new"
                  icon="el-icon-time"
                  @click="sendtakenotes(scope.row.sp_strategy_no,scope.row.push_method,scope.row.group_selection,scope.row.trigger_way)"
                >发送记录</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="text"
                  class="el-button-new"
                  icon="el-icon-folder-add"
                  @click="multiplex(scope.row.sp_strategy_no,3)"
                >复用</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="text"
                  class="el-button-new"
                  icon="el-icon-delete"
                  @click="deleter(scope.row.sp_strategy_no)"
                >删除</el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

    </el-table>
    <el-dialog
      :title="group_selection == 4 ? '绑定员工(将会以群主的身份发送到所有群)' : '绑定员工'"
      :visible.sync="dialogVisible"
      :class="{active:group_selection === 4}"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="1000px"
    >
      <bandstaff
        ref="bandstaffview"
        @bandarr="bandarr"
      />
    </el-dialog>
    <el-dialog
      title="绑定群组"
      :visible.sync="dialogVisiblegroup"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="50%"
    >
      <bandgroup
        ref="bandgroupview"
        @bandarr="bandarr"
      />
    </el-dialog>
    <el-dialog
      :title="group_selection == 4 ? '绑定员工(将会以群主的身份发送到所有群)' : '绑定员工'"
      :class="{active:group_selection === 4}"
      :visible.sync="dialogVisiblelabel"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :width="group_selection == 1 && push_method ==1 ? '1000px' : '1000px'"
    >
      <bandlabel
        ref="bandlabelview"
        @bandarr="bandarr"
        @callbacklabel="callbacklabel"
      />
    </el-dialog>
    <el-dialog
      title="绑定拉群规则"
      :visible.sync="dialogVisiblerule"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <bandrule
        ref="bandruleview"
        @callbackrule="callbackrule"
      />
    </el-dialog>
    <el-dialog
      title="设置群"
      :visible.sync="dialogVisiblesetup"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="50%"
    >
      <setup
        ref="setupview"
        @setuparr="setuparr"
      />
    </el-dialog>
    <el-dialog
      title="绑定失败的员工/群聊"
      :visible.sync="dialogVisibleerror"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="50%"
    >
      <errorstaff ref="bandstafferrorview" />
    </el-dialog>
    <el-dialog
      title="绑定记录"
      :visible.sync="dialogVisiblenotes"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="80%"
    >
      <bandnote
        ref="bandstaffnotesview"
        @updata="updata"
      />
    </el-dialog>
    <el-dialog
      title="失败列表"
      :visible.sync="dialogVisibleinawr"
      width="50%"
    >
      <el-table
        :data="fail_strategy"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="sp_strategy_no"
          label="编号"
          width="300"
          align="center"
        />
        <el-table-column
          prop="remark"
          label="备注"
          align="center"
        />
      </el-table>
    </el-dialog>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import bandstaff from './components/bandstaff.vue'
import errorstaff from './components/errorstaff.vue'
import bandnote from './components/bandnote.vue'
import bandgroup from './components/bandgroup.vue'
import setup from './components/setup.vue'
import bandlabel from './components/bandlabel.vue'
import bandrule from './components/bandrule.vue'
import { spMessagelisttactics, sprbindEmployeeNos, sprdeletecover, bindGroupChats, bindEmployeeNos, bindGroupRule, suspendStrategy } from '@/api/officialaccount.js'
export default {
  name: 'Enterprisemilist',
  components: { PaginationRight, bandstaff, errorstaff, bandnote, bandgroup, setup, bandlabel, bandrule },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      dialogVisible: false,
      dialogVisibleerror: false,
      dialogVisiblenotes: false,
      dialogVisiblegroup: false,
      dialogVisiblesetup: false,
      dialogVisiblelabel: false,
      dialogVisiblerule: false,
      isMobile: window.innerWidth <= 768,
      query: {
        page: 1,
        pageSize: 10,
        keywords: null,
        // sp_strategy_no: null,
        // sp_strategy_title: null,
        onlyMe: 2,
        push_method: '',
        sp_strategy_type: 0,
        status: 0
      },
      accountarr: [
        {
          value: 1,
          label: '查看组内策略消息'
        },
        {
          value: 2,
          label: '我关联的策略消息'
        }
      ],
      push_method: null,
      accountarrsa: [
        {
          value: '',
          label: '全部发送方式'
        },
        {
          value: 1,
          label: '官方接口'
        },
        {
          value: 2,
          label: '第三方接口'
        },
        {
          value: 4,
          label: 'webflow'
        }
      ],
      sparr: [
        {
          value: 0,
          label: '全部策略类型'
        },
        {
          value: 1,
          label: '欢迎语'
        },
        {
          value: 2,
          label: '定时推送'
        },
        {
          value: 4,
          label: '关键词回复'
        },
        {
          value: 5,
          label: '延时推送'
        }
      ],
      statusarr: [
        {
          value: 0,
          label: '全部状态'
        },
        {
          value: 1,
          label: '正常状态'
        },
        {
          value: 2,
          label: '暂停状态'
        }
      ],
      group_selection: null,
      selectlist: [],
      selectlistsend: [],
      dialogVisibleinawr: false,
      fail_strategy: []
    }
  },
  created() {
    this.list()
    if (this.$route.query.ids) {
      this.query.keywords = this.$route.query.ids
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  activated() {
    if (this.$route.query.ids) {
      this.query.keywords = this.$route.query.ids
    }
    this.list()
  },
  methods: {
    rowKey(row) {
      return row.id
    },
    suspendStrat(row) {
      this.$confirm(`确定要${row.status === 2 ? '启用' : '暂停'}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          suspendStrategy({
            sp_strategy_nos: [row.sp_strategy_no],
            // eslint-disable-next-line eqeqeq
            status: row.status == 2 ? 1 : 2
          }).then(res => {
            this.$message({
              type: 'success',
              // eslint-disable-next-line eqeqeq
              message: `${row.status == 2 ? '启用成功!' : '暂停成功!'}`
            })
            this.list()
          })
        })
        .catch(() => {})
    },
    async list() {
      this.loading = true
      const data = await spMessagelisttactics(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.query.push_method = ''
      this.query.sp_strategy_type = 0
      this.query.status = 0
      // this.query.sp_strategy_no = null
      // this.query.sp_strategy_title = null
      this.list()
    },
    add() {
      this.$router.push({ path: '/enterpridialog/index' })
    },
    // 复用
    multiplex(id, type) {
      this.$router.push({ path: '/enterpridialog/index', query: { id: id, type: type }})
    },
    bandstaff(id, type, push_method, sp_strategy_type, trigger_way) {
      this.push_method = push_method
      this.group_selection = type
      // eslint-disable-next-line eqeqeq
      if (type === 1 || type == 4) {
        // this.dialogVisible = true
        // this.$nextTick(() => {
        //   this.$refs.bandstaffview.sendr(id)
        // })
        this.dialogVisiblelabel = true
        this.$nextTick(() => {
          this.$refs.bandlabelview.sendr(id, type, push_method, sp_strategy_type)
        })
      } else if (type === 2) {
        this.dialogVisiblegroup = true
        this.$nextTick(() => {
          this.$refs.bandgroupview.send(id)
        })
      } else if (Number(type) === 6) {
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.bandstaffview.sendr(id)
        })
      } else {
        this.dialogVisiblesetup = true
        this.$nextTick(() => {
          this.$refs.setupview.sendr(id, trigger_way)
        })
      }
    },
    async bandarr(arr, sp_strategy_no, type) {
      const data = await sprbindEmployeeNos({
        sp_strategy_no: sp_strategy_no,
        employee_nos: arr,
        push_method: this.push_method
      })
      // eslint-disable-next-line eqeqeq
      if (this.group_selection == 6) {
        this.dialogVisible = false
      } else if (type === 1) {
        this.dialogVisiblelabel = false
      } else {
        this.dialogVisiblegroup = false
      }

      if (data.data.fails.length === 0) {
        this.$message({
          message: '绑定成功',
          type: 'success'
        })
      } else {
        this.dialogVisibleerror = true
        this.$nextTick(() => {
          this.$refs.bandstafferrorview.send(data.data.fails)
        })
      }
    },
    async callbacklabel(allarr, arrsw, sp_strategy_no, group_value, not_tag_user) {
      try {
        const data = await bindEmployeeNos({
          sp_strategy_no: sp_strategy_no,
          change_tags: group_value === true ? allarr : [],
          employee_nos: arrsw,
          not_tag_user
        })

        if (data.data.fails.length === 0) {
          this.dialogVisiblelabel = false
          this.$message({
            message: '绑定成功',
            type: 'success'
          })
        } else {
          this.dialogVisiblelabel = false
          this.dialogVisibleerror = true
          this.$nextTick(() => {
            this.$refs.bandstafferrorview.send(data.data.fails)
          })
        }
      } catch {
        console.log('错误')
        this.$nextTick(() => {
          this.$refs.bandlabelview.noloading()
        })
      }
    },
    async setuparr(arr, sp_strategy_no) {
      try {
        const data = await bindGroupChats({
          sp_strategy_no: sp_strategy_no,
          group_chat_ids: arr
        })

        this.dialogVisiblesetup = false
        if (data.data.fails.length === 0) {
          this.$message({
            message: '绑定成功',
            type: 'success'
          })
        } else {
          this.dialogVisibleerror = true
          this.$nextTick(() => {
            this.$refs.bandstafferrorview.send(data.data.fails)
          })
        }
      } catch {
        this.$nextTick(() => {
          this.$refs.setupview.loadr()
        })
      }
    },
    bandtakenotes(val) {
      var tag_show = false
      if (val.group_selection === 1 && val.push_method === 1 && val.sp_strategy_type === 2) {
        tag_show = true
      }
      this.dialogVisiblenotes = true
      this.$nextTick(() => {
        this.$refs.bandstaffnotesview.send(val.sp_strategy_no, val.type, val.push_method, tag_show, val.group_selection)
      })
    },
    updata() {
      this.dialogVisiblenotes = false
      // this.list()
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 768
    },
    deleter(id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          sprdeletecover({
            sp_strategy_nos: [id]
          }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.list()
          })
        })
        .catch(() => {})
    },
    async sendtakenotes(id, push_method, group_selection, trigger_way) {
      const routeOpt = {
        path: '/sendlink/index',
        query: { id, push_method }
      }

      // 满足条件追加type=1
      if (push_method === 2 && trigger_way === 2 && [1, 3, 5].includes(group_selection)) {
        routeOpt.query.type = 1
        console.log('请求其他接口')
      }
      if (group_selection === 5) {
        routeOpt.query.group_selection = group_selection
      }

      this.$router.push(routeOpt)
    },
    bandrule(sp_strategy_no) {
      this.dialogVisiblerule = true
      this.$nextTick(() => {
        this.$refs.bandruleview.sendr(sp_strategy_no)
      })
    },
    async callbackrule(arr, sp_strategy_no) {
      const data = await bindGroupRule({
        sp_strategy_no: sp_strategy_no,
        chat_set_id: arr
      })
      console.log(data)
      this.$message({
        type: 'success',
        message: '绑定成功!'
      })
      this.dialogVisiblerule = false
    },
    handleSelectionChange(rows) {
      this.selectlist = rows //
    },
    batchDelete() {
      console.log('this.selectlist', this.selectlist)
      this.selectlistsend = []
      this.selectlistsend = this.selectlist.map((item, index) => {
        // eslint-disable-next-line eqeqeq
        return item.sp_strategy_no
      })
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          sprdeletecover({
            sp_strategy_nos: this.selectlistsend
          }).then(res => {
            this.$message({
              type: 'success',
              message: `${res.message}`
            })
            this.selectlist = []
            this.$refs.multipleTable.clearSelection()
            setTimeout(() => {
              this.list()
            }, 2000)
          })
        })
        .catch(() => {})
    },
    batchStop() {
      console.log('this.selectlist', this.selectlist)
      this.selectlistsend = []
      this.selectlistsend = this.selectlist.map((item, index) => {
        // eslint-disable-next-line eqeqeq
        return item.sp_strategy_no
      })
      this.$confirm('确定要暂停吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          suspendStrategy({
            sp_strategy_nos: this.selectlistsend,
            status: 2
          }).then(res => {
            // this.$message({
            //   type: 'success',
            //   message: `${res.message}`
            // })
            this.selectlist = []
            this.$refs.multipleTable.clearSelection()
            // eslint-disable-next-line eqeqeq
            if (res.data.fail_strategy.length != 0) {
              this.dialogVisibleinawr = true
              this.fail_strategy = []
              this.fail_strategy = res.data.fail_strategy
            }
            setTimeout(() => {
              this.list()
            }, 2000)
          })
        })
        .catch(() => {})
    },
    batchStar() {
      console.log('this.selectlist', this.selectlist)
      this.selectlistsend = []
      this.selectlistsend = this.selectlist.map((item, index) => {
        // eslint-disable-next-line eqeqeq
        return item.sp_strategy_no
      })
      this.$confirm('确定要启用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          suspendStrategy({
            sp_strategy_nos: this.selectlistsend,
            status: 1
          }).then(res => {
            // this.$message({
            //   type: 'success',
            //   message: `${res.message}`
            // })
            // eslint-disable-next-line eqeqeq
            if (res.data.fail_strategy.length != 0) {
              this.dialogVisibleinawr = true
              this.fail_strategy = []
              this.fail_strategy = res.data.fail_strategy
            }
            this.selectlist = []
            this.$refs.multipleTable.clearSelection()
            setTimeout(() => {
              this.list()
            }, 2000)
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sp_view {
  padding: 30px;
}
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.content_box {
  width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
.sedrtw {
  width: 130px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
.active /deep/ .el-dialog__title {
  color: red;
}
.el-button-new {
}
@media (max-width: 768px){
  .el-dropdown-link{
    font-size:2.5vw;
  }
}
</style>
